// @ts-check
import {
  l10n,
  linkToCommunity,
  renderPreview,
  renderPublicList,
} from "./sotd.js";
import { html } from "../../core/import-maps.js";

/**
 * @param {Conf} conf
 * @param {{ additionalContent: DocumentFragment; additionalSections: NodeList; mailToWGPublicListWithSubject?: string; mailToWGPublicListSubscription?: string }} opts
 */
export default (conf, opts) => {
  return html`
    <h2>${l10n.sotd}</h2>
    ${conf.isPreview ? renderPreview(conf) : ""}
    <p>
      This specification was published by the
      <a href="${conf.wgURI}">${conf.wg}</a>. It is not a W3C Standard nor is it
      on the W3C Standards Track.
      ${conf.isCGFinal
        ? html`
            Please note that under the
            <a href="https://www.w3.org/community/about/agreements/final/"
              >W3C Community Final Specification Agreement (FSA)</a
            >
            other conditions apply.
          `
        : html`
            Please note that under the
            <a href="https://www.w3.org/community/about/agreements/cla/"
              >W3C Community Contributor License Agreement (CLA)</a
            >
            there is a limited opt-out and other conditions apply.
          `}
      Learn more about
      <a href="https://www.w3.org/community/"
        >W3C Community and Business Groups</a
      >.
    </p>
    ${!conf.sotdAfterWGinfo ? opts.additionalContent : ""}
    ${!conf.github && conf.wgPublicList ? renderPublicList(conf, opts) : ""}
    ${conf.github ? linkToCommunity(conf, opts) : ""}
    ${conf.sotdAfterWGinfo ? opts.additionalContent : ""}
    ${opts.additionalSections}
  `;
};
